module.exports = __webpack_public_path__ + "static/media/GBP-MIF-599-Medication-Guide_2023-01.50860dde.pdf";